import { parseCurrency } from '@helper/parseCurrency'

export const parseReportBudgetData = (data: any[]): any[] => {
  const res = []

  for (const item of data) {
    res.push({
      'orcamento-id': item.id,
      'orcamento-ano': item.ano,
      'orcamento-empresa': item.empresaId + '-' + item.empresaDescricao,
      'orcamento-loja': item.lojaId
        ? item.lojaId + ' - ' + item.lojaDescricao
        : '',
      'orcamento-fator-venda': parseCurrency({
        value: item.fatorVendaBruta,
        country: 'pt-br'
      }),
      'orcamento-du-passado':
        item.diasUteisUltimoAno + ' / ' + item.diasUteisAnoAtual,
      'orcamento-real-proj': parseCurrency({
        value: item.vendasUltimoAno,
        country: 'pt-br'
      }),
      'orcamento-diferenca-ajustada': parseCurrency({
        value: item.diferencaAjustada,
        country: 'pt-br'
      }),
      'orcamento-final': parseCurrency({
        value: item.orcamentoFinal,
        country: 'pt-br'
      })
    })
  }

  return res
}
